module.exports = __webpack_public_path__ + "img/pro_one_5.5f40e277.jpg";